import { render, staticRenderFns } from "./successText.vue?vue&type=template&id=71bfc645&scoped=true&"
import script from "./successText.vue?vue&type=script&lang=js&"
export * from "./successText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bfc645",
  null
  
)

export default component.exports